import Swal from 'sweetalert2';

export const SwalPremium = Swal.mixin({
  background: 'rgba(255, 255, 255, 0.85)',
  backdrop: 'rgba(15, 23, 42, 0.5)',
  buttonsStyling: false,
  showClass: {
    popup: 'swal2-premium-show',
    backdrop: 'swal2-backdrop-show'
  },
  hideClass: {
    popup: 'swal2-premium-hide'
  },
  customClass: {
    popup: 'backdrop-blur-2xl border border-white/60 rounded-[32px] shadow-2xl p-6',
    title: 'text-xl font-black text-slate-800 tracking-tight',
    htmlContainer: 'text-sm font-bold text-slate-500 mt-2',
    actions: 'flex gap-3 mt-6',
    confirmButton: 'bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-xl font-black uppercase text-xs tracking-wider shadow-md shadow-blue-500/30 transition-all cursor-pointer hover:-translate-y-0.5',
    cancelButton: 'bg-slate-100 hover:bg-slate-200 text-slate-700 px-6 py-3 rounded-xl font-black uppercase text-xs tracking-wider transition-all shadow-sm cursor-pointer',
    denyButton: 'bg-rose-500 hover:bg-rose-600 text-white px-6 py-3 rounded-xl font-black uppercase text-xs tracking-wider shadow-md shadow-rose-500/30 transition-all cursor-pointer hover:-translate-y-0.5'
  }
});